import { gql } from "@apollo/client";

const GET_ADJUSTMENT_TYPES = gql`
  query GetAdjustmentTypes {
    adjustmentTypes {
      count
      items {
        id
        typeName
        typeKey
        subTypes {
          id
          subTypeName
          subTypeKey
          deductionTypeCategory {
            deductionTypeCategoryId
            deductionTypeCategoryKey
            deductionTypeCategoryName
          }
        }
      }
    }
  }
`;

export default GET_ADJUSTMENT_TYPES;
